module.exports = __webpack_public_path__ + "img/export_excel.4a3d1c2f.svg";